import actionCreatorFactory from 'typescript-fsa'

import { FacebookPage, GetCategoriesResponse, MediaFileMetadata } from '@3m5/sm_publish-frontend-api/models'
import {
  GetAllFacebookCategoriesRequest,
  GetFacebookPageRequest,
  SaveFacebookPageInformationRequest, UpdateCoverImageRequest, UpdateProfileImageRequest,
} from '@3m5/sm_publish-frontend-api/apis/FacebookPageApi'
import {
  ListMediaFilesRequest,
  UploadMediaFileRequest,
  UploadTemporaryMediaFileRequest,
} from '@3m5/sm_publish-frontend-api'
import {
  SetUpdateImprintAutomaticallyForCurrentUserRequest
} from '@professocialApi/professocial-core-frontend-api/apis/ImprintApi'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const getFacebookPageInitiated = actionCreator<GetFacebookPageRequest>('GET_FACEBOOK_PAGE_INITIATED')
export const getFacebookPage = actionCreator.async<GetFacebookPageRequest, FacebookPage>('GET_FACEBOOK_PAGE')

export const saveFacebookPageInformationInitiated = actionCreator<SaveFacebookPageInformationRequest>('SAVE_FACEBOOK_PAGE_INFORMATION_INITIATED')
export const saveFacebookPageInformation = actionCreator.async<SaveFacebookPageInformationRequest, undefined>('SAVE_FACEBOOK_PAGE_INFORMATION')

export const getPotentialPageImprintInitiated = actionCreator<undefined>('GET_POTENTIAL_PAGE_IMPRINT_INITIATED')
export const getPotentialPageImprint = actionCreator.async<undefined, string>('GET_POTENTIAL_PAGE_IMPRINT')

export const getAllFacebookCategoriesInitiated = actionCreator<GetAllFacebookCategoriesRequest>('GET_ALL_FACEBOOK_CATEGORIES_INITIATED')
export const getAllFacebookCategories = actionCreator.async<GetAllFacebookCategoriesRequest, GetCategoriesResponse>('GET_ALL_FACEBOOK_CATEGORIES')

export const uploadMediaFileInitiated = actionCreator<UploadMediaFileRequest>('UPLOAD_MEDIA_FILE_INITIATED')
export const uploadMediaFile = actionCreator.async<UploadMediaFileRequest, MediaFileMetadata>('UPLOAD_MEDIA_FILE')

export const updateCoverImageInitiated = actionCreator<UpdateCoverImageRequest>('UPLOAD_COVER_IMAGE_INITIATED')
export const updateCoverImage = actionCreator.async<UpdateCoverImageRequest, undefined>('UPLOAD_COVER_IMAGE')

export const updateProfileImageInitiated = actionCreator<UpdateProfileImageRequest>('UPLOAD_PROFILE_IMAGE_INITIATED')
export const updateProfileImage = actionCreator.async<UpdateProfileImageRequest, undefined>('UPLOAD_PROFILE_IMAGE')

export const listMediaFilesInitiated = actionCreator<ListMediaFilesRequest>('LIST_MEDIA_FILES_INITIATED')
export const listMediaFiles = actionCreator.async<ListMediaFilesRequest, MediaFileMetadata[]>('LIST_MEDIA_FILES')

export const listProfileImagesInitiated = actionCreator('LIST_PROFILE_IMAGES_INITIATED')
export const listProfileImages = actionCreator.async<undefined, MediaFileMetadata[]>('LIST_PROFILE_IMAGES')

export const listCoverImagesInitiated = actionCreator('LIST_COVER_IMAGES_INITIATED')
export const listCoverImages = actionCreator.async<undefined, MediaFileMetadata[]>('LIST_COVER_IMAGES')

export const uploadProfileMediaFileInitiated = actionCreator<UploadTemporaryMediaFileRequest>('UPLOAD_PROFILE_MEDIA_FILE_INITIATED')
export const uploadProfileMediaFile = actionCreator.async<UploadTemporaryMediaFileRequest, MediaFileMetadata>('UPLOAD_PROFILE_MEDIA_FILE')

export const uploadCoverMediaFileInitiated = actionCreator<UploadTemporaryMediaFileRequest>('UPLOAD_COVER_MEDIA_FILE_INITIATED')
export const uploadCoverMediaFile = actionCreator.async<UploadTemporaryMediaFileRequest, MediaFileMetadata>('UPLOAD_COVER_MEDIA_FILE')

export const setUpdateImprintAutomaticallyForCurrentUserInitiated = actionCreator<SetUpdateImprintAutomaticallyForCurrentUserRequest>('SET_UPDATE_IMPRINT_AUTO_INITIATED')
export const setUpdateImprintAutomaticallyForCurrentUser = actionCreator.async<SetUpdateImprintAutomaticallyForCurrentUserRequest, undefined>('SET_UPDATE_IMPRINT_AUTO')
